<template>
    <div class="card">
        <div class="card-header">
          <button @click="() => open = !open" class="btn" type="button" data-toggle="collapse" data-target="#changePasswordCollapse" aria-expanded="false" aria-controls="changePasswordCollapse">
            <i v-if="open" class="fas fa-angle-up"></i>
            <i v-else class="fas fa-angle-down"></i>
            <h4 data-target="#changePasswordCollapse" aria-expanded="false" aria-controls="changePasswordCollapse" class="btn alert-heading font-18 text-dark">Փոխել գաղտնաբառ</h4>
          </button>
        </div>
        <div id="changePasswordCollapse" class="collapse multi-collapse">
          <div class="card-body">
              <div class="p-3">
                  <form class="form-parsley" action="#" novalidate="">
                      <div class="form-group row">
                          <label class="col-lg-4 col-form-label text-right">Հին գաղտնաբառ</label>
                          <div class="input-user col-xl-4 col-lg-8 d-flex">
                              <input
                                  id="old_password"
                                  v-model="$v.fields.old_password.$model"
                                  type="password"
                                  class="auth-input form-control"
                                  :class="{'border-danger': isInvalidField('old_password', 'required') || isInvalidField('old_password', 'minLength')}"
                                  name="old_password"
                              />
                          </div>
                          <div v-if="isInvalidField('old_password', 'required')" class="small text-danger">{{ $t('state_customer.valid_1') }}</div>
                          <div v-if="isInvalidField('old_password', 'minLength')" class="small text-danger"> {{ $t('state_customer.valid_4') }}</div>
                      </div>
                      <div class="form-group row">
                          <label class="col-lg-4 col-form-label text-right">Նոր գաղտնաբառ</label>
                          <div class="input-user col-xl-4 col-lg-8 d-flex">
                              <input
                                  id="password"
                                  v-model="$v.fields.password.$model"
                                  type="password"
                                  class="auth-input form-control"
                                  :class="{'border-danger': isInvalidField('password', 'required') || isInvalidField('password', 'minLength')}"
                                  name="password"
                              />
                          </div>
                          <div v-if="isInvalidField('password', 'required')" class="small text-danger">{{ $t('state_customer.valid_1') }}</div>
                          <div v-if="isInvalidField('password', 'minLength')" class="small text-danger"> {{ $t('state_customer.valid_4') }}</div>
                      </div>
                      <div class="form-group row">
                          <label class="col-lg-4 col-form-label text-right">Կրկնել գաղտնաբառ</label>
                          <div class="input-user col-xl-4  col-lg-8 d-flex">
                              <input
                                  id="repeat-password"
                                  v-model="$v.fields.password_confirmation.$model"
                                  type="password"
                                  class="auth-input form-control"
                                  :class="{'border-danger': isInvalidField('password_confirmation', 'required') || isInvalidField('password_confirmation', 'sameAsPassword')}"
                                  name="repeat-password"
                              />
                          </div>
                          <div v-if="isInvalidField('password_confirmation', 'required')" class="small text-danger">{{ $t('state_customer.valid_1') }}</div>
                          <div v-if="isInvalidField('password_confirmation', 'sameAsPassword')" class="small text-danger">{{ $t('state_customer.valid_5') }}</div>
                      </div>
                  </form>
              </div>
             <div class="bg-white w-100 pr-0 text-right" style="bottom: 0">
                <button @click="save" type="button" class="btn btn-primary mb-3 waves-effect waves-light float-right" data-toggle="modal" data-animation="bounce">
                    Պահպանել
                </button>
              </div>
          </div>
        </div>
    </div>
</template>
<script>
import { minLength, sameAs, required } from 'vuelidate/lib/validators'

export default {
  name: 'personalSettings',
  data () {
    return {
      open: false,
      fields: {
        old_password: '',
        password: '',
        password_confirmation: '',
      },
    }
  },
  validations: {
    fields: {
        old_password: { required, minLength: minLength(6) },
        password: { required, minLength: minLength(6) },
        password_confirmation: { required, sameAsPassword: sameAs('password') },
    },
  },
  computed: {
    me() {
      return this.$store.getters['user/me']
    },
  },
  methods: {
    consoleLog(e){
      console.log(e)
    },
    save() {
      if(!this.$v.fields.$invalid) {
        $client.put(`user-password`, this.fields).then(({data}) => {
          console.log(data)
          if(data === 'success'){
            this.$notify({
              group: 'foo',
              type: 'success',
              text: 'Հաջողությամբ պահպանված է'
            })
          } else if(data === 'wrong old password') {
            this.$notify({
              group: 'foo',
              type: 'error',
              text: 'Հին գաղտանբառը սխալ է',
              title: 'Կրկին փորձեք!'
            })
          }
        }).catch(e => {
          this.$notify({
            group: 'foo',
            type: 'error',
            title: 'Էլ. հացեն զբաղված է',
            text: 'Կրկին փորձեք!'
          })
        })
      } else {
        this.$v.fields.$touch()
      }
    },
    isInvalidField (pathToField, validator) {
      const keyArr = pathToField.split('.')
      const field = keyArr.reduce((acc, key) => {
        return acc[key]
      }, this.$v.fields)
      return validator === 'required' ?
        field.$dirty && !field.required :
        field.required && !field[validator]
    }
  },
}
</script>
